import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { ButtonModule } from '../button/button.module';
import { FloatingModule } from '../floating/floating.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { SmartbarModule } from '../smartbar';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { ModalAnalyticsService } from './modal-analytics.service';
import { ModalComponent } from './modal.component';

@NgModule({
  imports: [CommonModule, NgbModalModule, ButtonModule, SvgIconModule, ScrollbarModule, SmartbarModule, FloatingModule],
  declarations: [ModalComponent],
  providers: [ModalAnalyticsService],
  exports: [ModalComponent]
})
export class ModalModule {}

export * from './modal-analytics.service';
export * from './modal.component';
